import { render, staticRenderFns } from "./redPackDetail.vue?vue&type=template&id=5b7d97b5&"
import script from "./redPackDetail.vue?vue&type=script&lang=js&"
export * from "./redPackDetail.vue?vue&type=script&lang=js&"
import style0 from "./redPackDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports